export default __webpack_public_path__ + "static/media/category-banner-SalesRegion.c9396707.jpg";